import React from 'react';
import { connect } from 'react-redux';

import { getWalletAccountsList } from 'client/multiWallet/_redux';
import { getTradingAccount, getTradingAccountList, getTradingAccountTypes } from '../../../_redux';
import { getDepositSystemList, getAvailableLpas } from '../../_redux';
import { PaymentsPanel } from '../../_components';

const DepositPage = props => <PaymentsPanel {...props} />;

export default connect(
  state => {
    const action = state.interfaceConfig.addons.includes('wallet') ? 'wallet_deposit' : 'deposit';

    return {
      paymentSystemList: state.client.payments.depositSystems,
      availableLpasList: state.client.payments.availableLpas,
      initialLoading: state.client.common.loadingAccounts || state.client.payments.loadingDepositSystems,
      addons: state.interfaceConfig.addons,
      captionSlug: 'clientDeposit',
      action,
    };
  },
  {
    loadAccounts: () => getTradingAccountList.request(true),
    loadPaymentSystems: () => getDepositSystemList.request(),
    getAvailableLpas: slug => getAvailableLpas.request(slug),
    loadAccount: id => getTradingAccount.request(id),
    getTradingAccountTypes: () => getTradingAccountTypes.request(),
    getWalletAccountsList: () => getWalletAccountsList.request(),
  }
)(DepositPage);
export { DepositPage };
